export enum Dataset {
  HP_CAPACITY_SUBSCRIBED_SUM = 'SUBSCRIBED_CAPACITY',
  HP_CAPACITY_LOGICAL_SUM = 'LOGICAL_CAPACITY',
  HP_CAPACITY_PHYSICAL_SUM = 'PHYSICAL_CAPACITY',

  EMC_CAPACITY_SUBSCRIBED_SUM = 'SUBSCRIBED_CAPACITY_EMC',
  EMC_CAPACITY_NET_SUM = 'NET_CAPACITY_EMC',
  EMC_CAPACITY_PHYSICAL_SUM = 'PHYSICAL_CAPACITY_EMC',

  HP_CAPACITY_PHYSICAL_PERSYSTEM = 'CAPACITY',
  HP_WORKLOAD_PERSYSTEM = 'WORKLOAD',
  HP_TRANSFER_PERSYSTEM = 'TRANSFER',

  EMC_CAPACITY_PHYSICAL_PERSYSTEM = 'CAPACITY_PERSYSTEM_EMC',
  EMC_WORKLOAD_PERSYSTEM = 'WORKLOAD_PERSYSTEM_EMC',
  EMC_TRANSFER_PERSYSTEM = 'TRANSFER_PERSYSTEM_EMC',

  HP_BLOCKSIZE_READ_AVG = 'BLOCKSIZE_READ',
  HP_BLOCKSIZE_WRITE_AVG = 'BLOCKSIZE_WRITE',

  HP_WORKLOAD_SUM = 'WORKLOAD_SUM',
  HP_TRANSFER_SUM = 'TRANSFER_SUM',

  EMC_WORKLOAD_SUM = 'WORKLOAD_EMC',
  EMC_TRANSFER_SUM = 'TRANSFER_EMC',
}
